<template>
  <div>
    <GmapAutocomplete :selectFirstOnEnter="true" :placeholder="placeholder" v-model="enderecoFormatado" class="form-control" @place_changed="setPlace"></GmapAutocomplete>
  </div>
</template>
<script>
import eventBus from '@/event-bus'

export default {
  props: {
    placeholder: {
      type: String,
      default: 'Informe o bairro ou cidade'
    }
  },
  computed: {
    enderecoFormatado () {
      return this.$store.getters.enderecoFormatado
    }
  },
  methods: {
    setPlace (place) {
      this.$store.dispatch('setLocal', place)
        .then(() => {
          if (this.$route.name === 'Busca') {
            this.$store.dispatch('busca')
          }
          eventBus.$emit('onSetPlace', place)
        })
    },
    geolocate () {
      if (!window.google || !window.google.maps) {
        return false
      }
      let self = this
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          var gPosition = new window.google.maps.LatLng(geolocation.lat, geolocation.lng)

          var geocoder = new window.google.maps.Geocoder()
          geocoder.geocode(
            { 'latLng': gPosition },
            function (results, status) {
              if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
                self.$store.dispatch('setLocal', results[1])
              }
            }
          )
        })
      }
    }
  },
  mounted () {
    if (!this.enderecoFormatado) {
      this.geolocate()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/GoogleMapsAutocomplete.vue